  (function() {
    var SECTION_ID = document.querySelector(".pairs-well-with-section").getAttribute("data-section-id");
    var sectionEl = document.getElementById('pairs-well-with-' + SECTION_ID);
    if (!sectionEl) return;

    /* ---- Initialize carousel & ATC on current content ---- */
    initSection();

    /* ---- Sync widget when cart is updated externally (e.g. cart drawer qty change/remove) ---- */
    document.addEventListener('cart:updated', function(e) {
      var cart = e.detail && e.detail.cart;
      if (!cart) return;
      syncWidgetWithCart(cart);
    });

    /* ---- Also sync when cart drawer closes (catches removal edge cases) ---- */
    var cartDrawerEl = document.querySelector('cart-drawer');
    if (cartDrawerEl) {
      var observer = new MutationObserver(function(mutations) {
        // When cart drawer loses 'active' class (closing), sync state
        var isClosing = mutations.some(function(m) {
          return m.type === 'attributes' && m.attributeName === 'class' && !cartDrawerEl.classList.contains('active');
        });
        if (isClosing) {
          fetch('/cart.js', { credentials: 'same-origin', headers: { 'Content-Type': 'application/json' } })
            .then(function(r) { return r.json(); })
            .then(function(cart) { syncWidgetWithCart(cart); })
            .catch(function() {});
        }
      });
      observer.observe(cartDrawerEl, { attributes: true, attributeFilter: ['class'] });
    }

    /* ---- Re-render on variant change via Section Rendering API ---- */
    window.addEventListener('gallery-recreated', function() {
      var variantId = null;
      var variantPicker = document.querySelector('variant-radios, variant-selects');
      if (variantPicker && variantPicker.currentVariant) {
        variantId = String(variantPicker.currentVariant.id);
      }
      if (!variantId) {
        variantId = new URLSearchParams(window.location.search).get('variant');
      }
      if (!variantId) {
        var formInput = document.querySelector('form[action*="/cart/add"] input[name="id"]');
        if (formInput && formInput.value) variantId = formInput.value;
      }
      if (!variantId) return;

      var basePath = window.location.pathname;
      var fetchUrl = basePath + '?variant=' + variantId + '&section_id=' + SECTION_ID;

      fetch(fetchUrl)
        .then(function(response) { return response.text(); })
        .then(function(html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          var newSectionEl = doc.getElementById('pairs-well-with-' + SECTION_ID);
          if (!newSectionEl) {
            var shopifyWrapper = doc.getElementById('shopify-section-' + SECTION_ID);
            if (shopifyWrapper) {
              newSectionEl = shopifyWrapper.querySelector('[id^="pairs-well-with"]');
            }
          }
          if (!newSectionEl) {
            newSectionEl = doc.querySelector('.pairs-well-with-section');
          }
          if (newSectionEl) {
            var hasContent = newSectionEl.querySelector('.pairs-well-with__container');
            if (hasContent) {
              sectionEl.innerHTML = newSectionEl.innerHTML;
              sectionEl.style.display = '';
              initSection();
              return;
            }
          }
          sectionEl.innerHTML = '';
          sectionEl.style.display = 'none';
        })
        .catch(function(err) {
          console.error('[Pairs Well With] Section update failed:', err);
        });
    });

    /* ---- Section initialization (carousel + ATC) ---- */
    function initSection() {
      var track = sectionEl.querySelector('.pairs-well-with__carousel-track');
      var prevBtn = sectionEl.querySelector('.pairs-well-with__arrow--prev');
      var nextBtn = sectionEl.querySelector('.pairs-well-with__arrow--next');

      if (!track) return;

      function updateArrows() {
        if (!track || !prevBtn || !nextBtn) return;
        var scrollLeft = Math.round(track.scrollLeft);
        var maxScroll = track.scrollWidth - track.clientWidth;
        prevBtn.disabled = scrollLeft <= 2;
        nextBtn.disabled = maxScroll <= 2 || scrollLeft >= maxScroll - 2;
      }

      function scrollByCard(direction) {
        var card = track.querySelector('.pairs-well-with__card');
        if (!card) return;
        var cardWidth = card.offsetWidth + 10;
        track.scrollBy({ left: direction * cardWidth, behavior: 'smooth' });
      }

      if (prevBtn) prevBtn.addEventListener('click', function() { scrollByCard(-1); });
      if (nextBtn) nextBtn.addEventListener('click', function() { scrollByCard(1); });
      track.addEventListener('scroll', updateArrows);
      setTimeout(updateArrows, 100);

      // Add to cart buttons (desktop + mobile)
      sectionEl.querySelectorAll('.pairs-well-with__add-to-cart, .pairs-well-with__add-to-cart-mobile').forEach(function(btn) {
        btn.addEventListener('click', function() { handleAddToCart(btn); });
      });

      // Mobile quantity control: add (+) button
      sectionEl.querySelectorAll('.pairs-well-with__qty-add').forEach(function(btn) {
        btn.addEventListener('click', function() {
          var qtyControl = btn.closest('.pairs-well-with__mobile-qty-control');
          var variantId = qtyControl.dataset.variantId;
          handleQtyChange(variantId, 1, qtyControl);
        });
      });

      // Mobile quantity control: remove (trash) button
      sectionEl.querySelectorAll('.pairs-well-with__qty-remove').forEach(function(btn) {
        btn.addEventListener('click', function() {
          var qtyControl = btn.closest('.pairs-well-with__mobile-qty-control');
          var variantId = qtyControl.dataset.variantId;
          handleQtyChange(variantId, -1, qtyControl);
        });
      });
    }

    /* ---- Add to cart logic ---- */
    function handleAddToCart(btn) {
      var variantId = btn.dataset.variantId;
      if (!variantId || btn.disabled) return;

      var card = btn.closest(".pairs-well-with__card");
      var closestCartStatusContainer = card.querySelector(".pairs-well-with__card-item-cart-status-container");
      var mobileQtyControl = card.querySelector('.pairs-well-with__mobile-qty-control[data-variant-id="' + variantId + '"]');
      var cardAction = card.querySelector('.pairs-well-with__card-action');

      // Loading state
      btn.disabled = true;
      btn.classList.add('pairs-well-with__atc--loading');
      var sectionsToRequest = ['cart-icon-bubble'];

      fetch(window.routes.cart_add_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({
          items: [{ id: parseInt(variantId), quantity: 1 }],
          sections: sectionsToRequest.join(','),
          sections_url: window.location.pathname
        })
      })
      .then(function(response) {
        if(!response.ok) {
            btn.disabled = false;
            btn.classList.remove('pairs-well-with__atc--loading');
            throw new Error('Cart change failed: ' + response.status);
        }
        return response.text();
       })
      .then(function(state) {
        const parsedResponse = JSON.parse(state);
        var qty = parsedResponse.items[0].quantity;

        // Desktop: show badge overlay on image
        if (closestCartStatusContainer) {
          closestCartStatusContainer.querySelector(".pwwc_added-to-cart-count").textContent = qty;
          closestCartStatusContainer.classList.add("is-active");
        }

        // Mobile: show qty control, hide ATC button
        if (mobileQtyControl) {
          mobileQtyControl.querySelector('.pairs-well-with__qty-count').textContent = qty;
          mobileQtyControl.classList.add('is-active');
          if (cardAction) cardAction.classList.add('has-qty');
        }

        // Update cart bubble
        if (parsedResponse.sections && parsedResponse.sections['cart-icon-bubble']) {
          var bubbleEl = document.getElementById('cart-icon-bubble');
          if (bubbleEl) {
            var parsed = new DOMParser().parseFromString(parsedResponse.sections['cart-icon-bubble'], 'text/html');
            var newBubble = parsed.querySelector('.shopify-section');
            if (newBubble) bubbleEl.innerHTML = newBubble.innerHTML;
          }
        }
      })
      .catch(function(err) {
        console.error('[Pairs Well With] Add to cart failed:', err);
      })
      .finally(function() {
        btn.disabled = false;
        btn.classList.remove('pairs-well-with__atc--loading');
      });
    }

    /* ---- Quantity change (mobile +/- control) ---- */
    function handleQtyChange(variantId, delta, qtyControl) {
      var countEl = qtyControl.querySelector('.pairs-well-with__qty-count');
      var currentQty = parseInt(countEl.textContent) || 0;
      var newQty = currentQty + delta;

      if (newQty < 0) newQty = 0;

      // Find related elements
      var card = qtyControl.closest('.pairs-well-with__card');
      var cardAction = card.querySelector('.pairs-well-with__card-action');
      var closestCartStatusContainer = card.querySelector('.pairs-well-with__card-item-cart-status-container');

      // If removing to 0, reset to ATC button
      if (newQty === 0) {
        // Remove from cart via cart/change
        fetch(window.routes.cart_change_url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({
            id: variantId,
            quantity: 0,
            sections: 'cart-icon-bubble',
            sections_url: window.location.pathname
          })
        })
        .then(function(response) { return response.json(); })
        .then(function(data) {
          // Hide qty control, show ATC button again
          qtyControl.classList.remove('is-active');
          if (cardAction) cardAction.classList.remove('has-qty');

          // Hide desktop badge
          if (closestCartStatusContainer) {
            closestCartStatusContainer.classList.remove('is-active');
          }

          // Update cart bubble
          if (data.sections && data.sections['cart-icon-bubble']) {
            var bubbleEl = document.getElementById('cart-icon-bubble');
            if (bubbleEl) {
              var parsed = new DOMParser().parseFromString(data.sections['cart-icon-bubble'], 'text/html');
              var newBubble = parsed.querySelector('.shopify-section');
              if (newBubble) bubbleEl.innerHTML = newBubble.innerHTML;
            }
          }
        })
        .catch(function(err) {
          console.error('[Pairs Well With] Remove from cart failed:', err);
        });
        return;
      }

      // Otherwise update quantity
      countEl.textContent = newQty;

      fetch(window.routes.cart_change_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({
          id: variantId,
          quantity: newQty,
          sections: 'cart-icon-bubble',
          sections_url: window.location.pathname
        })
      })
      .then(function(response) { return response.json(); })
      .then(function(data) {
        // Update desktop badge count too
        if (closestCartStatusContainer) {
          closestCartStatusContainer.querySelector('.pwwc_added-to-cart-count').textContent = newQty;
        }

        // Update cart bubble
        if (data.sections && data.sections['cart-icon-bubble']) {
          var bubbleEl = document.getElementById('cart-icon-bubble');
          if (bubbleEl) {
            var parsed = new DOMParser().parseFromString(data.sections['cart-icon-bubble'], 'text/html');
            var newBubble = parsed.querySelector('.shopify-section');
            if (newBubble) bubbleEl.innerHTML = newBubble.innerHTML;
          }
        }
      })
      .catch(function(err) {
        console.error('[Pairs Well With] Qty change failed:', err);
        // Revert count on error
        countEl.textContent = currentQty;
      });
    }

    /* ---- Sync widget state when cart is modified externally ---- */
    function syncWidgetWithCart(cart) {
      // Build a map of variant_id → quantity from the cart items
      var cartMap = {};
      if (cart.items && cart.items.length) {
        cart.items.forEach(function(item) {
          cartMap[String(item.variant_id)] = item.quantity;
        });
      }

      // Update each card in the widget
      sectionEl.querySelectorAll('.pairs-well-with__card[data-variant-id]').forEach(function(card) {
        var variantId = card.getAttribute('data-variant-id');
        var qty = cartMap[variantId] || 0;

        var statusContainer = card.querySelector('.pairs-well-with__card-item-cart-status-container');
        var mobileQtyControl = card.querySelector('.pairs-well-with__mobile-qty-control');
        var cardAction = card.querySelector('.pairs-well-with__card-action');

        if (qty > 0) {
          // Item is in cart — show feedback
          if (statusContainer) {
            statusContainer.querySelector('.pwwc_added-to-cart-count').textContent = qty;
            statusContainer.classList.add('is-active');
          }
          if (mobileQtyControl) {
            mobileQtyControl.querySelector('.pairs-well-with__qty-count').textContent = qty;
            mobileQtyControl.classList.add('is-active');
            if (cardAction) cardAction.classList.add('has-qty');
          }
        } else {
          // Item removed from cart — reset to default state
          if (statusContainer) {
            statusContainer.classList.remove('is-active');
          }
          if (mobileQtyControl) {
            mobileQtyControl.classList.remove('is-active');
            if (cardAction) cardAction.classList.remove('has-qty');
          }
        }
      });
    }

  })();